import React from "react";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import { useLkm } from "./useLkm";
import { constantNoMesin, bulan, tahun } from "../../util/constant";
import RefreshIcon from "../../Assets/refresh-icon.png";
import QrIcon from "../../Assets/qr-icon.png";
import ScanLogo from "../../Assets/scan-logo.png";
import Select from "react-select";
import moment from "moment";
import QRCode from "react-qr-code";
import { hasRole } from "../../util/utilFunction";
import LkmSignatures from "./LkmSignatures";
import LkmPrintSheet from "./LkmPrintSheet";
import LkmAnalytics from "./LkmAnalytics";
import { getLkmStatus, formatNoLkm, hasVal } from "../../util/lkmUtil";
import "./LKM.css";

const LKM = () => {
  const {
    dataUser,
    popUpNewLkm,
    setPopUpNewLkm,
    handleCloseNewLkm,
    jenisLkm,
    setJenisLkm,
    keBagian,
    setKeBagian,
    customerNewLkm,
    setCustomerNewLkm,
    dataListMold,
    moldNewLkm,
    setMoldNewLkm,
    mesinNewLkm,
    setMesinNewLkm,
    dataTempMold,
    deskripsiKerusakan,
    handleFormChange,
    addFields,
    removeFields,
    perbaikan,
    setPerbaikan,
    pencegahan,
    setPencegahan,
    handleSubmitNewLkm,
    isDisabled,
    setIsDisabled,
    isError,
    subMenu,
    setSubMenu,
    setIsRefresh,
    dataListLkm,
    dataAnalytics,
    popUpDetailLkm,
    openDetailLkm,
    handleCloseDetailLkm,
    pickDetailLkm,
    setPickDetailLkm,
    popUpQrCode,
    setPopUpQrCode,
    qrCode,
    setQrCode,
    filterBulanLkm,
    setFilterBulanLkm,
    filterTahunLkm,
    setFilterTahunLkm,
    filterJenisLkm,
    setFilterJenisLkm,
    filterItemLkm,
    setFilterItemLkm,
    reFormat,
    handleResetFilterLkm,
    dataTempPoSearch,
    popUpScan,
    setPopUpScan,
    ref,
    errMsg,
    handleScan,
    handleApprove,
    dataHeader,
    editPerbaikan,
    setEditPerbaikan,
    editPencegahan,
    setEditPencegahan,
    handleEditPerbaikan,
  } = useLkm();

  const totalMonthToMonth = dataHeader && dataHeader.pertambahanRequest;
  const firstName = (name) => (name ? name.split(" ")[0] : "");
  const withDate = (name, date) =>
    name
      ? `${firstName(name)}${
          date ? ` - ${moment(date).format("DD-MM-YY HH:mm")}` : ""
        }`
      : "";

  const jenisSelect = (style) => (
    <select
      className="select-filter-bulan-tahun-lkm"
      onChange={(e) => setFilterJenisLkm(e.target.value)}
      style={style}
      value={filterJenisLkm}
    >
      <option disabled value="Jenis">
        Jenis
      </option>
      <option value="MESIN">MESIN</option>
      <option value="MOLD">MOLD</option>
      <option value="BAHAN">BAHAN</option>
    </select>
  );

  const tahunSelect = (
    <select
      className="select-filter-bulan-tahun-lkm"
      style={{ marginRight: "6px", marginBottom: "6px" }}
      onChange={(e) => setFilterTahunLkm(e.target.value)}
      value={filterTahunLkm}
    >
      {tahun.map((ele) => (
        <option key={ele} value={ele}>
          {ele}
        </option>
      ))}
    </select>
  );

  return (
    <>
      {/* ===== Popup: LKM baru ===== */}
      {popUpNewLkm && (
        <PopUpComponent className="wrapper-popup-newLkm">
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => handleCloseNewLkm()}
              alt="close_logo"
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "6px",
              width: "98%",
            }}
          >
            <select
              className="input-select-jenis-lkm"
              value={keBagian}
              style={
                isError && keBagian === "Ke Bagian"
                  ? { border: "2px solid red" }
                  : {}
              }
              onChange={(e) => setKeBagian(e.target.value)}
            >
              <option disabled value="Ke Bagian">
                Ke Bagian
              </option>
              <option value="M Mesin">M Mesin</option>
              <option value="M Mold">M Mold</option>
              <option value="GUDANG & EKSPEDISI">GUDANG</option>
              <option value="PRODUKSI">PRODUKSI</option>
            </select>

            <select
              className="input-select-jenis-lkm"
              style={
                isError && jenisLkm === "Jenis LKM"
                  ? { border: "2px solid red" }
                  : {}
              }
              value={jenisLkm}
              onChange={(e) => setJenisLkm(e.target.value)}
            >
              <option disabled value="Jenis LKM">
                Jenis LKM
              </option>
              <option value="MESIN">MESIN</option>
              <option value="MOLD">MOLD</option>
              <option value="BAHAN">BAHAN</option>
            </select>

            <select
              className="input-select-jenis-lkm"
              style={
                isError && mesinNewLkm === "Mesin"
                  ? { border: "2px solid red" }
                  : {}
              }
              value={mesinNewLkm}
              onChange={(e) => setMesinNewLkm(e.target.value)}
            >
              <option disabled value="Mesin">
                Mesin
              </option>
              {constantNoMesin.map((data) => (
                <option key={data} value={data}>
                  {data}
                </option>
              ))}
            </select>
            <select
              className="input-select-jenis-lkm"
              style={
                isError && customerNewLkm === "Customer"
                  ? { border: "2px solid red" }
                  : {}
              }
              value={customerNewLkm}
              onChange={(e) => {
                setCustomerNewLkm(e.target.value);
                setMoldNewLkm(null);
              }}
            >
              <option disabled value="Customer">
                Customer
              </option>
              {dataListMold &&
                dataListMold.map((data) => (
                  <option key={data.company} value={data.company}>
                    {data.company}
                  </option>
                ))}
            </select>
            <div
              className="select_item_gbj"
              style={isError && !moldNewLkm ? { border: "2px solid red" } : {}}
            >
              <Select
                options={dataTempMold}
                value={moldNewLkm}
                onChange={setMoldNewLkm}
                placeholder="Mold"
              />
            </div>
          </div>

          {deskripsiKerusakan.map((data, index) => (
            <div key={index} style={{ display: "flex", marginBottom: "6px" }}>
              <p style={{ margin: "6px 12px 0 0" }}>{index + 1}. </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  width: "98%",
                }}
              >
                <div className="width-wrapper-bagian-penyebab">
                  <p className="font-lkm" style={{ margin: "6px 0" }}>
                    Bagian yang Rusak
                  </p>
                  <input
                    type="text"
                    className="input-deskripsi-new-lkm"
                    name="bagianRusak"
                    placeholder="Bagian yang Rusak"
                    onChange={(e) => handleFormChange(index, e)}
                    value={data.bagianRusak}
                  />
                </div>
                <div className="width-wrapper-bagian-penyebab">
                  <p className="font-lkm" style={{ margin: "6px 0" }}>
                    Penyebab Kerusakan
                  </p>
                  <input
                    type="text"
                    className="input-deskripsi-new-lkm"
                    name="penyebab"
                    placeholder="Penyebab Kerusakan"
                    onChange={(e) => handleFormChange(index, e)}
                    value={data.penyebab}
                  />
                </div>
              </div>
            </div>
          ))}
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "12px",
            }}
          >
            <div>
              <button
                className="button-plus-minus-lkm"
                style={{ marginRight: "16px" }}
                onClick={() => removeFields()}
              >
                &#8722;
              </button>
              <button
                className="button-plus-minus-lkm"
                onClick={() => addFields()}
              >
                &#43;
              </button>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                width: "98%",
              }}
            >
              <div className="width-wrapper-deskripsi">
                <p className="font-lkm">Perbaikan yang Dilakukan</p>
                <textarea
                  className="textarea-lkm"
                  value={perbaikan}
                  onChange={(e) => setPerbaikan(e.target.value)}
                  placeholder="Perbaikan yang Dilakukan"
                />
              </div>
              <div className="width-wrapper-deskripsi">
                <p className="font-lkm">Tindakan Pencegahan</p>
                <textarea
                  className="textarea-lkm"
                  value={pencegahan}
                  onChange={(e) => setPencegahan(e.target.value)}
                  placeholder="Tindakan Pencegahan"
                />
              </div>
            </div>
          </div>
          <button
            className="button-kirim-new-lkm"
            disabled={isDisabled}
            onClick={() => {
              setIsDisabled(true);
              handleSubmitNewLkm();
            }}
          >
            Kirim
          </button>
        </PopUpComponent>
      )}

      {/* ===== Popup: detail LKM ===== */}
      {popUpDetailLkm && pickDetailLkm && (
        <>
          <PopUpComponent className="wrapper-popup-newLkm">
            <div className="lkm-detail-head">
              <div className="lkm-detail-title">
                <p className="lkm-detail-form">Form-ENG-A2-R2</p>
                <p className="lkm-detail-no">{formatNoLkm(pickDetailLkm)}</p>
                <span
                  className={`lkm-badge lkm-badge-${
                    getLkmStatus(pickDetailLkm).key
                  }`}
                >
                  {getLkmStatus(pickDetailLkm).label}
                </span>
              </div>
              <div className="lkm-detail-actions">
                <button
                  className="btn-cetak-lkm"
                  onClick={() => window.print()}
                >
                  Cetak / PDF
                </button>
                <img
                  style={{ width: "36px", height: "36px", cursor: "pointer" }}
                  src={CloseLogo}
                  onClick={() => handleCloseDetailLkm()}
                  alt="close_logo"
                />
              </div>
            </div>

            <dl className="lkm-info">
              <div>
                <dt>Tanggal</dt>
                <dd>{moment(pickDetailLkm.createDate).format("DD-MM-YYYY")}</dd>
              </div>
              <div>
                <dt>Jam</dt>
                <dd>{moment(pickDetailLkm.createDate).format("HH:mm:ss")}</dd>
              </div>
              <div>
                <dt>Dari Bagian</dt>
                <dd>{pickDetailLkm.dariBagian}</dd>
              </div>
              <div>
                <dt>Ke Bagian</dt>
                <dd>{pickDetailLkm.keBagian}</dd>
              </div>
              <div>
                <dt>Jenis</dt>
                <dd>{pickDetailLkm.jenisLkm}</dd>
              </div>
              <div>
                <dt>Mesin</dt>
                <dd>MC {pickDetailLkm.mesin}</dd>
              </div>
              <div>
                <dt>Customer</dt>
                <dd>{pickDetailLkm.customer}</dd>
              </div>
              <div>
                <dt>Mold</dt>
                <dd>{pickDetailLkm.mold}</dd>
              </div>
            </dl>

            <table className="lkm-damage">
              <thead>
                <tr>
                  <th style={{ width: "40px" }}>No.</th>
                  <th>Bagian yang Rusak</th>
                  <th>Penyebab Kerusakan</th>
                </tr>
              </thead>
              <tbody>
                {(pickDetailLkm.penyebab || []).map((data, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{data.bagianRusak}</td>
                    <td>{data.penyebab}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="lkm-notes">
              <div>
                <p className="font-lkm">Perbaikan yang Dilakukan</p>
                <textarea
                  className="textarea-lkm"
                  value={editPerbaikan || ""}
                  disabled={hasVal(pickDetailLkm.verifikasi)}
                  onChange={(e) => setEditPerbaikan(e.target.value)}
                  placeholder="Perbaikan yang Dilakukan"
                />
              </div>
              <div>
                <p className="font-lkm">Tindakan Pencegahan</p>
                <textarea
                  className="textarea-lkm"
                  value={editPencegahan || ""}
                  disabled={hasVal(pickDetailLkm.verifikasi)}
                  onChange={(e) => setEditPencegahan(e.target.value)}
                  placeholder="Tindakan Pencegahan"
                />
              </div>
            </div>

            {!hasVal(pickDetailLkm.verifikasi) && (
              <div style={{ display: "flex", justifyContent: "end" }}>
                <button
                  className="button-kirim-new-lkm"
                  disabled={isDisabled}
                  onClick={() => {
                    setIsDisabled(true);
                    handleEditPerbaikan();
                  }}
                >
                  Update
                </button>
              </div>
            )}

            <LkmSignatures
              data={pickDetailLkm}
              dataUser={dataUser}
              onApprove={handleApprove}
            />
          </PopUpComponent>
          <LkmPrintSheet data={pickDetailLkm} dataUser={dataUser} />
        </>
      )}

      {/* ===== Popup: QR code ===== */}
      {popUpQrCode && pickDetailLkm && (
        <PopUpComponent>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }}>
              <p className="title-popup-detail-lkm margin-right-6px-lkm">
                <b>{moment(pickDetailLkm.createDate).format("DD-MM-YYYY")}</b>
              </p>
              <p className="title-popup-detail-lkm margin-right-6px-lkm">
                <b>{moment(pickDetailLkm.createDate).format("HH:mm:ss")}</b>
              </p>
              <p className="title-popup-detail-lkm margin-right-6px-lkm">
                <b>MC:</b> {pickDetailLkm.mesin}
              </p>
            </div>
            <img
              style={{ width: "36px", height: "36px", cursor: "pointer" }}
              src={CloseLogo}
              onClick={() => {
                setPickDetailLkm();
                setQrCode();
                setPopUpQrCode(false);
              }}
              alt="close_logo"
            />
          </div>
          <p
            style={{ margin: "0 0 18px 0" }}
            className="title-popup-detail-lkm margin-right-6px-lkm"
          >
            <b>{pickDetailLkm.mold}</b>
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <QRCode
              value={qrCode}
              style={{ width: "148px", height: "148px" }}
            />
          </div>
        </PopUpComponent>
      )}

      {/* ===== Popup: scan ===== */}
      {popUpScan && (
        <PopUpComponent style={{ marginTop: "calc(100vh - 95vh - 20px)" }}>
          <div ref={ref} id="qr" style={{ marginBottom: "12px" }}></div>
          <div style={{ marginBottom: "12px" }}></div>
          <p style={{ color: "red" }}>{errMsg}</p>
          <div
            className="wrapper_button_submit_popup"
            style={{ justifyContent: "end" }}
          >
            <button
              className="button_popup background_red"
              onClick={() => setPopUpScan(false)}
            >
              Tutup
            </button>
          </div>
        </PopUpComponent>
      )}

      {/* ===== Halaman utama ===== */}
      <div className="container_lkm">
        <div
          className="wrapper-header-po"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <label className="title_inventory">
            Laporan Kerusakan Mold / Mesin
          </label>
          <div
            className="wrapper-button-tambah-lkm"
            onClick={() => setPopUpNewLkm(true)}
          >
            <p className="button-tambah-lkm">+</p>
            <button className="text-button-tambah-lkm">New LKM</button>
          </div>
        </div>
        <br />

        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <div className="wrapper-card-akumulasi">
            <label className="label-text-bpb">a</label>
            <div>
              <p style={{ margin: "6px 0 12px 0" }}>Total LKM</p>
              <p className="total-request-text">
                {dataHeader ? dataHeader.totalBulanIni : 0}&nbsp;Request
              </p>
              <p style={{ margin: "12px 0 6px 0" }}>
                {totalMonthToMonth >= 0 ? (
                  <label style={{ color: "green", fontWeight: 550 }}>
                    +{totalMonthToMonth}
                  </label>
                ) : (
                  <label style={{ color: "red", fontWeight: 550 }}>
                    {totalMonthToMonth}
                  </label>
                )}
                &nbsp;In this Month
              </p>
            </div>
          </div>
          <div className="wrapper-card-akumulasi">
            <label className="label-text-bpb">a</label>
            <div>
              <p style={{ margin: "6px 0 12px 0" }}>Open</p>
              <p className="total-request-text">
                {dataHeader && dataHeader.totalOpen}&nbsp;Request
              </p>
              <p style={{ margin: "12px 0 6px 0" }}></p>
            </div>
          </div>
          <div className="wrapper-card-akumulasi">
            <label className="label-text-bpb">a</label>
            <div>
              <p style={{ margin: "6px 0 12px 0" }}>On Proccess</p>
              <p className="total-request-text">
                {dataHeader && dataHeader.totalProses}&nbsp;Request
              </p>
              <p style={{ margin: "12px 0 6px 0" }}></p>
            </div>
          </div>
          <div className="wrapper-card-akumulasi">
            <label className="label-text-bpb">a</label>
            <div>
              <p style={{ margin: "6px 0 12px 0" }}>Done</p>
              <p className="total-request-text">
                {dataHeader && dataHeader.totalDone}&nbsp;Request
              </p>
              <p style={{ margin: "12px 0 6px 0" }}></p>
            </div>
          </div>
        </div>

        <br />
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {subMenu === "done" && (
              <>
                <select
                  style={{ marginRight: "6px", marginBottom: "6px" }}
                  className="select-filter-bulan-tahun-lkm"
                  onChange={(e) => setFilterBulanLkm(e.target.value)}
                  value={filterBulanLkm}
                >
                  <option disabled value="Bulan">
                    Bulan
                  </option>
                  {bulan.map((ele) => (
                    <option key={ele.value} value={ele.value}>
                      {ele.name}
                    </option>
                  ))}
                </select>
                {tahunSelect}
                {jenisSelect({ marginRight: "6px", marginBottom: "6px" })}
                <div style={{ margin: "0 6px 6px 0" }}>
                  <Select
                    options={reFormat}
                    className="select-item-lkm"
                    value={filterItemLkm || ""}
                    onChange={setFilterItemLkm}
                  />
                </div>
                <div style={{ borderRadius: "4px", marginRight: "6px" }}>
                  <button
                    className="button-reset-bpb"
                    onClick={() => handleResetFilterLkm()}
                  >
                    Reset
                  </button>
                </div>
              </>
            )}
            {subMenu === "analytics" && tahunSelect}
          </div>
        </div>

        <div className="wrapper-submenu-lkm">
          <p
            className={
              subMenu === "open" ? "submenu-lkm-active" : "submenu-lkm"
            }
            onClick={() => setSubMenu("open")}
          >
            Open
          </p>
          <p
            className={
              subMenu === "done" ? "submenu-lkm-active" : "submenu-lkm"
            }
            onClick={() => setSubMenu("done")}
          >
            Done
          </p>
          {hasRole(dataUser, "super_user") && (
            <p
              className={
                subMenu === "analytics" ? "submenu-lkm-active" : "submenu-lkm"
              }
              onClick={() => setSubMenu("analytics")}
            >
              Grafik
            </p>
          )}
          {subMenu === "open" && (
            <div className="lkm-submenu-filter">
              {jenisSelect({ marginRight: "6px" })}
            </div>
          )}
          <div className="lkm-submenu-actions">
            <img
              src={RefreshIcon}
              alt="refresh"
              className="button-refresh-qr-lkm"
              onClick={() => setIsRefresh(true)}
            />
            <img
              className="button-refresh-qr-lkm"
              src={ScanLogo}
              alt="scan"
              onClick={() => {
                setPopUpScan(true);
                handleScan();
              }}
            />
          </div>
        </div>

        {subMenu === "analytics" ? (
          <LkmAnalytics data={dataAnalytics} />
        ) : dataTempPoSearch && dataTempPoSearch.length > 0 ? (
          <div className="lkm-table-wrap">
            <table className="font10-mobile-lkm table-lkm">
              <thead>
                <tr>
                  <th style={{ padding: "8px 0px 8px 12px" }}>No.</th>
                  {subMenu === "open" && <th style={{ padding: "8px" }}>QR</th>}
                  <th style={{ padding: "8px" }}>No. LKM</th>
                  <th style={{ padding: "8px" }}>Tgl Nota</th>
                  <th style={{ padding: "8px" }}>Ke Bagian</th>
                  <th style={{ padding: "8px" }}>Jenis</th>
                  <th style={{ padding: "8px" }}>MC</th>
                  <th style={{ padding: "8px" }}>Mold</th>
                  <th style={{ padding: "8px" }}>Pembuat</th>
                  <th style={{ padding: "8px" }}>Penerima</th>
                  <th style={{ padding: "8px" }}>Mengetahui</th>
                  <th style={{ padding: "8px" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {dataTempPoSearch.map((data, index) => {
                  const status = getLkmStatus(data);
                  return (
                    <tr
                      key={data.id}
                      style={{
                        background: index % 2 === 0 ? "white" : "#F7F7F7",
                        cursor: "pointer",
                      }}
                      onClick={() => openDetailLkm(data)}
                    >
                      <td style={{ padding: "12px 0px 8px 12px" }}>
                        {index + 1}.
                      </td>
                      {subMenu === "open" && (
                        <td style={{ padding: "8px" }}>
                          <img
                            className="show-qr-lkm"
                            alt="qr"
                            onClick={(e) => {
                              e.stopPropagation();
                              setPopUpQrCode(true);
                              setPickDetailLkm(data);
                              setQrCode(
                                JSON.stringify({
                                  qrCode: data.id,
                                  name: dataUser.name,
                                })
                              );
                            }}
                            src={QrIcon}
                          />
                        </td>
                      )}
                      <td className="td-lkm">{formatNoLkm(data)}</td>
                      <td className="td-lkm">
                        {moment(data.createDate).format("DD-MM-YYYY - HH:mm")}
                      </td>
                      <td className="td-lkm">{data.keBagian}</td>
                      <td className="td-lkm">{data.jenisLkm}</td>
                      <td className="td-lkm">{data.mesin}</td>
                      <td className="td-lkm">{data.mold}</td>
                      <td className="td-lkm">{firstName(data.createdBy)}</td>
                      <td className="td-lkm">
                        {withDate(data.penerima, data.penerimaDate)}
                      </td>
                      <td className="td-lkm">
                        {withDate(data.diketahui, data.diketahuiDate)}
                      </td>
                      <td className="td-lkm">
                        <span className={`lkm-badge lkm-badge-${status.key}`}>
                          {status.label}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="lkm-empty">
            {subMenu === "open"
              ? "Tidak ada LKM yang masih open."
              : "Belum ada LKM selesai pada bulan ini."}
          </p>
        )}
      </div>
    </>
  );
};
export default LKM;
